import _defineProperty from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import request from '@/utils/request';

// 渠道入驻信息管理 - 获取列表
export function getApplyList(params) {
  return request({
    url: '/customer/channel-apply/index',
    method: 'get',
    params: params
  });
}

// 渠道合同管理 - 获取渠道合同
export function getContract(params) {
  return request({
    url: '/customer/channel-contract/get-channel-contract',
    method: 'get',
    params: params
  });
}

// 渠道合同管理 - 保存渠道合同
export function saveContract(data) {
  return request({
    url: '/customer/channel-contract/save-channel-contract',
    method: 'post',
    data: data
  });
}

// 渠道合同管理 - 获取预览链接
export function getSecretPath(params) {
  return request({
    url: '/customer/contract/upload/get-secret-path',
    method: 'get',
    params: params
  });
}

// 添加有效期延期
export function addOrderRule(data) {
  return request({
    url: '/orders/channel-order-rule/add',
    method: 'post',
    data: data
  });
}
// 编辑有效期延期
export function updateOrderRule(data) {
  return request({
    url: '/orders/channel-order-rule/up',
    method: 'post',
    data: data
  });
}
// 删除有效期延期
export function delOrderRule(data) {
  return request({
    url: '/orders/channel-order-rule/del',
    method: 'post',
    data: data
  });
}
// 售卡有效期规则列表
export function getOrderRuleList(data) {
  return request({
    url: '/orders/channel-order-rule/list',
    method: 'post',
    data: data
  });
}
// 标准账期列表
export function getOrdersPayList(data) {
  return request({
    url: '/orders/channel-payment-days/list',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 添加标准账期
export function addOrdersPayItem(data) {
  return request({
    url: '/orders/channel-payment-days/add',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 编辑标准账期
export function updateOrdersPayItem(data) {
  return request({
    url: '/orders/channel-payment-days/up',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 删除标准账期
export function delOrdersPayItem(data) {
  return request({
    url: '/orders/channel-payment-days/del',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 超期打折列表
export function getOrdersOverdueList(data) {
  return request({
    url: '/orders/channel-overdue-config/list',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 添加超期打折
export function addOrdersOverdueItem(data) {
  return request({
    url: '/orders/channel-overdue-config/add',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 编辑超期打折
export function updateOrdersOverdueItem(data) {
  return request({
    url: '/orders/channel-overdue-config/up',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 删除标准账期
export function delOrdersOverdueItem(data) {
  return request({
    url: '/orders/channel-overdue-config/del',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 获取卡类型列表
export function getCardTypeList(params) {
  return request({
    url: '/orders/channel-card-bin/index',
    method: 'get',
    params: params
  });
}
// 获取特殊品牌  业绩提成
export function getSpecialBrandList(params) {
  return request({
    url: '/orders/channel-card-bin/brands',
    method: 'get',
    params: params
  });
}
// 获取卡类型菜单
export function getCardTypeMenus(params) {
  return request({
    url: '/orders/channel-card-bin/card-bin-menus',
    method: 'get',
    params: params
  });
}
// 获取提成信息
export function getProportion(params) {
  return request({
    url: '/orders/channel-card-bin/get-proportion',
    method: 'get',
    params: params
  });
}
// 获取卡类型数据
export function getCardTypeData(data) {
  return request({
    url: '/orders/channel-card-bin/get-cardbin',
    method: 'post',
    data: data
  });
}
// 添加卡类型
export function cardBinAdd(data) {
  return request({
    url: '/orders/channel-card-bin/add',
    method: 'post',
    data: data
  });
}
// 编辑卡类型
export function upCardbin(data) {
  return request({
    url: '/orders/channel-card-bin/up-cardbin',
    method: 'post',
    data: data
  });
}
// 添加提成
export function addProportion(data) {
  return request({
    url: '/orders/channel-card-bin/add-proportion',
    method: 'post',
    data: data
  });
}
// 更新提成信息
export function updateProportion(params) {
  return request({
    url: '/orders/channel-card-bin/up-proportion',
    method: 'get',
    params: params
  });
}
// 删除提成
export function deleteCommission(params) {
  return request({
    url: '/orders/channel-card-bin/del',
    method: 'get',
    params: params
  });
}
// 渠道列表
export function getChannelList(params) {
  return request({
    url: '/user/channel/index',
    method: 'get',
    params: params
  });
}
// 获取短信签名
export function getChannelSms(params) {
  return request({
    url: '/user/channel/get-sms',
    method: 'get',
    params: params
  });
}
// 添加渠道
export function addChannel(data) {
  return request({
    url: '/user/channel/create',
    method: 'post',
    data: data
  });
}
// 编辑渠道
export function updateChannel(data) {
  return request({
    url: '/user/channel/update',
    method: 'post',
    data: data
  });
}
// 更新短信签名
export function getSynSmsSign(params) {
  return request({
    url: '/user/channel/get-syn-sms-sign',
    method: 'get',
    params: params
  });
}
// 编辑查看渠道
export function viewChannel(params) {
  return request({
    url: '/user/channel/update',
    method: 'get',
    params: params
  });
}
// 获取参数
export function getParamsChannel(params) {
  return request({
    url: '/user/channel/set-config',
    method: 'get',
    params: params
  });
}
// 提交参数配置
export function postParamsChannel(data) {
  return request({
    url: '/user/channel/set-config',
    method: 'post',
    data: data
  });
}
// 获取api配置
export function getChannelApi(params) {
  return request({
    url: '/user/channel/get-api',
    method: 'get',
    params: params
  });
}
// 查看api配置
export function getShowChannelApi(params) {
  return request({
    url: '/user/channel/show-api',
    method: 'get',
    params: params
  });
}
// 设置api
export function postChannelApi(data) {
  return request({
    url: '/user/channel/get-api',
    method: 'post',
    data: data
  });
}
// 更新渠道api
export function updateChannelApi(data) {
  return request({
    url: '/user/channel/set-api',
    method: 'post',
    data: data
  });
}
// 获取优联域名
export function getDomainLink(params) {
  return request({
    url: '/user/channel/domain-link',
    method: 'get',
    params: params
  });
}
// 添加城市
export function postChannelCity(data) {
  return request({
    url: '/user/channel/set-city',
    method: 'post',
    data: data
  });
}
// 获取城市列表
export function getChannelCityList(params) {
  return request({
    url: '/user/channel/set-citys',
    method: 'get',
    params: params
  });
}
// 移除城市
export function removeCityChannel(data) {
  return request({
    url: '/user/channel/remove-city',
    method: 'post',
    data: data
  });
}
// 移除城市
export function setDefaultCity(data) {
  return request({
    url: '/user/channel/set-default-city',
    method: 'post',
    data: data
  });
}
// 获取渠道公众号二维码
export function getCode2(params) {
  return request({
    url: '/user/channel/get-login-url',
    method: 'get',
    params: params
  });
}
// 获取渠道小程序二维码
export function getCode1(params) {
  return request({
    url: '/user/channel/get-login-img',
    method: 'get',
    params: params
  });
}
// 获取渠道公众号二维码-添加编辑渠道的
export function getCode(params) {
  return request({
    url: '/user/channel/get-wx-qr-code',
    method: 'get',
    params: params
  });
}
// 获取供应商列表
export function getCustomerList(data) {
  return request({
    url: '/orders/customer/list',
    method: 'post',
    data: data
  });
}
// 查看
export function getCustomerInfo(data) {
  return request({
    url: '/orders/customer/info',
    method: 'post',
    data: data
  });
}
// 发票列表
export function getInvoiceList(data) {
  var params = _objectSpread({}, data);
  // 兼容逻辑：如果没有传pagesize，则添加默认参数
  if (!params.pagesize) {
    params.page = 1;
    params.pagesize = 9999;
  }
  return request({
    url: '/orders/customer/invoice-list',
    method: 'post',
    data: params
  });
}
// 创建发票
export function createInvoice(data) {
  return request({
    url: '/orders/customer-invoice-account/create',
    method: 'post',
    data: data
  });
}
// 修改发票
export function editInvoice(data) {
  return request({
    url: '/orders/customer-invoice-account/update',
    method: 'put',
    data: data
  });
}

// 设为默认
export function setDefault(data) {
  return request({
    url: '/orders/customer-invoice-account/set-default',
    method: 'post',
    data: data
  });
}

// 创建客户
export function createCustomer(data) {
  return request({
    url: '/orders/customer/create',
    method: 'post',
    data: data
  });
}
// 编辑客户
export function editCustomer(data) {
  return request({
    url: '/orders/customer/update',
    method: 'post',
    data: data
  });
}
/**
 * 获取客户企业详情
 * @param {*} params
 * @returns
 */
export function getCustomerAccountInfo(params) {
  return request({
    url: '/customer/customer-account-new/get-customer-account-info',
    method: 'get',
    params: params
  });
}
/**
 * 设置客户企业详情保存
 * @param {*} data
 * @returns
 */
export function saveCustomerAccountInfo(data) {
  return request({
    url: '/customer/customer-account-new/save-customer-account-info',
    method: 'post',
    data: data
  });
}
/**
 * 获取客户企业个人中心
 * @param {*} params
 * @returns
 */
export function getCustomerAccountCenter(params) {
  return request({
    url: '/customer/customer-account-new/get-customer-account-center',
    method: 'get',
    params: params
  });
}
/**
 * 设置客户企业个人中心配置保存
 * @param {*} data
 * @returns
 */
export function saveCustomerAccountCenter(data) {
  return request({
    url: '/customer/customer-account-new/save-customer-account-center',
    method: 'post',
    data: data
  });
}
/**
 * 获取客户图片配置
 * @param {*} params
 * @returns
 */
export function getCustomerAccountImage(params) {
  return request({
    url: '/customer/customer-account-new/get-customer-account-image',
    method: 'get',
    params: params
  });
}
/**
 * 设置客户企业图片
 * @param {*} data
 * @returns
 */
export function saveCustomerAccountImage(data) {
  return request({
    url: '/customer/customer-account-new/save-customer-account-image',
    method: 'post',
    data: data
  });
}
/**
 * 获取客户企业图库图片
 * @param {*} params
 * @returns
 */
export function getgalleryList(params) {
  return request({
    url: '/mapdepot/map-depot-type/index-img',
    method: 'get',
    params: params
  });
}
/**
 * 获取客户企业高级设置
 * @param {*} params
 * @returns
 */
export function getCustomerAccountExtend(params) {
  return request({
    url: '/customer/customer-account-new/get-customer-account-extend',
    method: 'get',
    params: params
  });
}
/**
 * 高级设置保存
 * @param {*} data
 * @returns
 */
export function saveCustomerAccountExtend(data) {
  return request({
    url: '/customer/customer-account-new/save-customer-account-extend',
    method: 'post',
    data: data
  });
}
/**
 * 获取客户企业营销参数
 * @param {*} params
 * @returns
 */
export function getCustomerAccountMarketing(params) {
  return request({
    url: '/customer/customer-account-new/get-customer-account-marketing',
    method: 'get',
    params: params
  });
}
/**
 * 企业营销参数保存
 * @param {*} data
 * @returns
 */
export function saveCustomerAccountMarketing(data) {
  return request({
    url: '/customer/customer-account-new/save-customer-account-marketing',
    method: 'post',
    data: data
  });
}
/**
 * 获取客户企业影片列表
 * @param {*} params
 * @returns
 */
export function getMoviesList(params) {
  return request({
    url: '/customer/customer-account-new/get-movies-list',
    method: 'get',
    params: params
  });
}
/**
 * 设置客户企业影片黑名单
 * @param {*} data
 * @returns
 */
export function setBlackMovies(data) {
  return request({
    url: '/customer/customer-account-new/set-black-movies',
    method: 'post',
    data: data
  });
}
/**
 * 获取客户企业
 * @param {*} params
 * @returns
 */
export function getCustomerAccountOne(params) {
  return request({
    url: '/customer/customer-account-new/get-customer-account-one',
    method: 'get',
    params: params
  });
}

/**
 * 删除客户
 * @param {*} data
 * @returns
 */
export function delCustomer(data) {
  return request({
    url: '/orders/customer/del',
    method: 'post',
    data: data
  });
}
/**
 * 获取客户企业影院列表
 * @param {*} params
 * @returns
 */
export function getCinemaList(params) {
  return request({
    url: '/customer/customer-account-new/get-cinema-list',
    method: 'get',
    params: params
  });
}
/**
 * 设置客户企业影院黑名单
 * @param {*} data
 * @returns
 */
export function setBlackCinema(data) {
  return request({
    url: '/customer/customer-account-new/set-black-cinema',
    method: 'post',
    data: data
  });
}
/**
 * 获取客户企业操作日志-搜索项
 * @param {*} params
 * @returns
 */
export function getCustomerLogSearch(params) {
  return request({
    url: '/customer/customer-account-new/get-customer-log-search',
    method: 'get',
    params: params
  });
}
/**
 * 获取客户企业操作日志
 * @param {*} params
 * @returns
 */
export function channelCustomerLogList(params) {
  return request({
    url: '/customer/customer-account-new/channel-customer-log-list',
    method: 'get',
    params: params
  });
}
export function getAddUsername(data) {
  return request({
    url: '/orders/customer/get-add-username',
    method: 'post',
    data: data
  });
}
// 获取企业账号登陆saas链接
export function getSassUrl(params) {
  return request({
    url: '/customer/customer-account-new/saas-login',
    method: 'get',
    params: params
  });
}
// 获取渠道余额监控
export function getBalanceChannel(params) {
  return request({
    url: '/balance/balance-channel/lists',
    method: 'get',
    params: params
  });
}
// 商品资金账户 调整账户余额
export function setBalance(data) {
  return request({
    url: '/balance/balance-channel/set-balance',
    method: 'post',
    data: data
  });
}
// 服务费账户 设置账户余额
export function setServiceBalance(data) {
  return request({
    url: '/balance/balance-channel/set-service-balance',
    method: 'post',
    data: data
  });
}
// 渠道余额监控-操作-设置
export function setupbBalance(data) {
  return request({
    url: '/balance/balance-channel/setup',
    method: 'post',
    data: data
  });
}
// 渠道余额监控-操作-充值
export function recharge(data) {
  return request({
    url: '/balance/balance-channel/recharge',
    method: 'post',
    data: data
  });
}
// 渠道余额监控-操作-获取余额预警设置
export function getForewarning(params) {
  return request({
    url: '/balance/balance-channel/set-forewarning',
    method: 'get',
    params: params
  });
}
// 渠道余额监控-操作-修改余额预警设置
export function setForewarning(data) {
  return request({
    url: '/balance/balance-channel/set-forewarning',
    method: 'post',
    data: data
  });
}
// 渠道余额监控-操作-余额变动记录
export function getDetailInfo(params) {
  return request({
    url: '/balance/balance-channel/detail-info',
    method: 'get',
    params: params
  });
}
// 渠道余额监控-操作-余额变动记录导出
export function detailInfoExport(params) {
  return request({
    url: '/balance/balance-channel/detail-info-export',
    method: 'get',
    params: params
  });
}

// 渠道余额监控-操作-余额变动记录-交易流水
export function getDetailInfoLog(params) {
  return request({
    url: '/balance/balance-channel/detail-info-log',
    method: 'get',
    params: params,
    timeout: 3 * 60 * 1000
  });
}
// 渠道余额监控-操作-余额变动记录-交易流水导出
export function detailInfoLogExport(params) {
  return request({
    url: '/balance/balance-channel/detail-info-log-export',
    method: 'get',
    params: params
  });
}
// 渠道余额监控-操作-余额变动记录-交易流水-查询条件
export function getBalanceSearch(params) {
  return request({
    url: '/balance/balance-channel/search-types',
    method: 'get',
    params: params
  });
}
// 获取短信每日账单
export function getSmsBillDaily(params) {
  return request({
    url: '/customer/channel-sms-bill/get-channel-sms-bill-daily',
    method: 'get',
    params: params
  });
}
// 导出短信每日账单
export function exportSmsBillDaily(params) {
  return request({
    url: '/customer/channel-sms-bill/export-channel-sms-bill-daily',
    method: 'get',
    params: params
  });
}
// 获取短信账单明细搜索项
export function getBillDetailSearch(params) {
  return request({
    url: '/customer/channel-sms-bill/get-bill-detail-search',
    method: 'get',
    params: params
  });
}
// 获取短信账单明细
export function getSmsBillDetail(params) {
  return request({
    url: '/customer/channel-sms-bill/get-channel-sms-bill-detail',
    method: 'get',
    params: params
  });
}
// 导出短信账单明细
export function exportSmsBillDetail(params) {
  return request({
    url: '/customer/channel-sms-bill/export-channel-sms-bill-detail',
    method: 'get',
    params: params
  });
}
// 平台菜单
export function getPlatformList(params) {
  return request({
    url: '/malldecoration/mall-decoration/channel-platform-menu-index',
    method: 'get',
    params: params
  });
}
// 渠道菜单
export function getChanneMenulList(params) {
  return request({
    url: '/malldecoration/mall-decoration/channel-channel-menu-index',
    method: 'get',
    params: params
  });
}
// 启用禁用
export function changeMenuStatus(data) {
  return request({
    url: '/malldecoration/mall-decoration/channel-change-menu-status',
    method: 'post',
    data: data
  });
}
// 渠道-获取高级设置
export function getAdvancedSetting(params) {
  return request({
    url: '/user/channel/advanced-setting',
    method: 'get',
    params: params
  });
}
//  渠道-保存高级设置
export function saveAdvancedSetting(data) {
  return request({
    url: '/user/channel/save-advanced-setting',
    method: 'post',
    data: data
  });
}
// 渠道充值审核-列表
export function getBalanceChannelReview(params) {
  return request({
    url: '/balance/balance-channel-review/lists',
    method: 'get',
    params: params
  });
}
// 渠道充值审核-搜索
export function getSearchTypes(params) {
  return request({
    url: '/balance/balance-channel-review/search-types',
    method: 'get',
    params: params
  });
}
//  渠道充值审核-通过
export function reviewed(data) {
  return request({
    url: '/balance/balance-channel-review/reviewd',
    method: 'post',
    data: data
  });
}
//  渠道充值审核-驳回
export function reject(data) {
  return request({
    url: '/balance/balance-channel-review/reject',
    method: 'post',
    data: data
  });
}
//  渠道充值审核-确认
export function confirm(data) {
  return request({
    url: '/balance/balance-channel-review/confirm',
    method: 'post',
    data: data
  });
}
//  匹配服务费配额标准费率
export function matchServiceQuota(data) {
  return request({
    url: '/balance/balance-channel/match-service-quota',
    method: 'post',
    data: data
  });
}
// 冻结金额设置
export function setFreezeDay(data) {
  return request({
    url: '/orders/channel-overdue-config/set-freeze-day',
    method: 'post',
    data: data
  });
}
// 搜索框数据
export function getBalanceChannelSearch(params) {
  return request({
    url: '/balance/balance-channel/search-types-v2',
    method: 'get',
    params: params
  });
}
// 渠道创建对账单
export function createChannelStatement(data) {
  return request({
    url: '/balance/balance-channel/create-statement',
    method: 'post',
    data: data
  });
}
// 对账单详情上方数据
export function getBalanceChannelReconciliationDetailTop(params) {
  return request({
    url: '/balance/reconciliation/detail',
    method: 'get',
    params: params
  });
}
// 开票明细
export function getBalanceChannelInvoiceList(params) {
  return request({
    url: '/balance/reconciliation/get-invoice-lists',
    method: 'get',
    params: params
  });
}
// 交易明细
export function getBalanceChannelDetailInfoLog(params) {
  return request({
    url: '/balance/balance-channel/detail-info-log',
    method: 'get',
    params: params
  });
}
// 渠道对账管理搜索项数据
export function getChannelReconciliationSearchTypes(params) {
  return request({
    url: '/balance/reconciliation/search-types',
    method: 'get',
    params: params
  });
}
// 渠道对账管理列表
export function getChannelReconciliationList(params) {
  return request({
    url: '/balance/reconciliation/lists',
    method: 'get',
    params: params
  });
}
// 对账单导出
export function reconciliationExport(params) {
  return request({
    url: '/balance/reconciliation/export',
    method: 'get',
    params: params,
    timeout: 3 * 60 * 1000
  });
}
// 对账单作废
export function reconciliationCancel(params) {
  return request({
    url: '/balance/reconciliation/cancel',
    method: 'get',
    params: params
  });
}
// 批量修改开票状态
export function batchUpdateReconciliationInvoiceStatus(params) {
  return request({
    url: '/balance/reconciliation/batch-update-invoice-status',
    method: 'get',
    params: params
  });
}
// 批量移除
export function batchUpdateTransactionRemove(params) {
  return request({
    url: '/balance/reconciliation/batch-remove',
    method: 'get',
    params: params
  });
}
// 获取售后配置
export function getAfterSalesSettings(params) {
  return request({
    url: '/user/channel/after-sales-settings',
    method: 'get',
    params: params
  });
}
// 提交售后配置
export function postAfterSalesSettings(data) {
  return request({
    url: '/user/channel/after-sales-settings',
    method: 'post',
    data: data
  });
}
// 获取白名单列表
export function getChannelRiskList(params) {
  return request({
    url: '/user/channel-risk/index',
    method: 'get',
    params: params
  });
}
// 创建白名单
export function createChannelRisk(data) {
  return request({
    url: '/user/channel-risk/create',
    method: 'post',
    data: data
  });
}
// 编辑白名单
export function updateChannelRisk(data) {
  return request({
    url: '/user/channel-risk/update',
    method: 'post',
    data: data
  });
}
// 移除白名单
export function delChannelRisk(params) {
  return request({
    url: '/user/channel-risk/delete',
    method: 'get',
    params: params
  });
}
// 修改开票信息
export function changeInvoiceItem(data) {
  return request({
    url: '/balance/balance-channel/edit-billing-item',
    method: 'post',
    data: data
  });
}
// 修改开票状态 对账状态
export function changeInvoiceStatus(data) {
  return request({
    url: '/balance/balance-channel/edit-status',
    method: 'post',
    data: data
  });
}
// 修改对账状态
export function changeBillingStatus(data) {
  return request({
    url: '/balance/balance-channel/edit-bill-status',
    method: 'post',
    data: data
  });
}
// 获取变动类型 联动
export function getBalanceChannelType(params) {
  return request({
    url: '/balance/balance-channel/get-search-type',
    method: 'get',
    params: params
  });
}
// 对账单明细导出
export function getBalanceChannelInfoLogExport(params) {
  return request({
    url: '/balance/balance-channel/detail-info-log-export',
    method: 'get',
    params: params
  });
}
// 商品限购设置-按选中项
export function channelQuotaByChecked(data) {
  return request({
    url: '/malldecoration/channel-category-goods/quota-by-checked',
    method: 'post',
    data: data
  });
}
// 商品限购设置-按条件
export function channelQuotaByCondition(data) {
  return request({
    url: '/malldecoration/channel-category-goods/quota-by-condition',
    method: 'post',
    data: data
  });
}
// 渠道菜单下拉数据 搜索
export function getChannelMenusType(params) {
  return request({
    url: '/malldecoration/category-region/menus-type',
    method: 'get',
    params: params
  });
}
// 渠道列表-搜索条件
export function getOption(params) {
  return request({
    url: '/user/channel/get-option',
    method: 'get',
    params: params
  });
}
// 渠道列表-高级设置-查看例外
export function getException(params) {
  return request({
    url: '/user/channel-movie-risk/mobile-index',
    method: 'get',
    params: params
  });
}
// 渠道列表-高级设置-查看例外-添加配置
export function addException(data) {
  return request({
    url: '/user/channel-movie-risk/mobile-create',
    method: 'post',
    data: data
  });
}
// 渠道列表-高级设置-查看例外-更新配置
export function updateException(data) {
  return request({
    url: '/user/channel-movie-risk/mobile-update',
    method: 'post',
    data: data
  });
}
// 渠道列表-高级设置-查看例外-配置-删除
export function mobileDelete(params) {
  return request({
    url: 'user/channel-movie-risk/mobile-delete',
    method: 'get',
    params: params
  });
}
// 创建对账单预览
export function previewChannelStatement(data) {
  return request({
    url: '/balance/balance-channel/preview-statement',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 预览刷新
export function refreshChannelStatement(data) {
  return request({
    url: '/balance/balance-channel/refresh-statement',
    method: 'post',
    data: data
  });
}
// 预览汇总信息
export function previewChannelStatementDetail(params) {
  return request({
    url: '/balance/reconciliation/preview-detail',
    method: 'get',
    params: params
  });
}
// 预览开票明细
export function previewBalanceChannelInvoiceList(params) {
  return request({
    url: '/balance/reconciliation/get-preview-invoice-lists',
    method: 'get',
    params: params
  });
}
// 预览交易类型列表
export function previewTransactionTypeList(params) {
  return request({
    url: '/balance/reconciliation/get-preview-trading-lists',
    method: 'get',
    params: params
  });
}
// 详情交易类型列表
export function transactionTypeList(params) {
  return request({
    url: '/balance/reconciliation/get-trading-lists',
    method: 'get',
    params: params
  });
}
// 预览 创建对账单
export function createPreviewChannelStatement(params) {
  return request({
    url: '/balance/reconciliation/confirm-create',
    method: 'get',
    params: params
  });
}
// 取消预览
export function previewClearBalanceChannelStatement(params) {
  return request({
    url: '/balance/reconciliation/clear-preview',
    method: 'get',
    params: params
  });
}
// 清楚预览缓存
export function clearPreviewReconciliation(params) {
  return request({
    url: '/balance/reconciliation/clear-preview',
    method: 'get',
    params: params
  });
}
// 获取渠道合同列表
export function getChannelContractList(params) {
  return request({
    url: '/customer/channel-contract/get-channel-contract-list',
    method: 'get',
    params: params
  });
}
// 导出
export function exportBalanceChannelReview(params) {
  return request({
    url: '/balance/balance-channel-review/export',
    method: 'get',
    params: params
  });
}
// 获取渠道合同详情
export function getChannelContractDetail(params) {
  return request({
    url: '/customer/channel-contract/get-channel-contract',
    method: 'get',
    params: params
  });
}
// 保存渠道合同
export function saveChannelContract(data) {
  return request({
    url: '/customer/channel-contract/save-channel-contract',
    method: 'post',
    data: data
  });
}
// 上传充值截图
export function upImageBalanceChannelReview(data) {
  return request({
    url: '/balance/balance-channel-review/up-image',
    method: 'post',
    data: data
  });
}
// 移除渠道合同
export function removeChannelContract(data) {
  return request({
    url: '/customer/channel-contract/del-channel-contract',
    method: 'post',
    data: data
  });
}
// 获取需要提醒的渠道合同
export function contractRemind(params) {
  return request({
    url: '/user/channel/contract-remind',
    method: 'get',
    params: params
  });
}
// 获取渠道开票信息
export function channelInvoiceInfo(params) {
  return request({
    url: '/user/channel-invoice-information/info',
    method: 'get',
    params: params
  });
}
// 设置渠道开票信息
export function saveInvoiceInfo(data) {
  return request({
    url: '/user/channel-invoice-information/save',
    method: 'post',
    data: data
  });
}
// 批量移除
export function channelBalanceBatchRemoveInvoice(params) {
  return request({
    url: '/balance/reconciliation/batch-remove-invoice',
    method: 'get',
    params: params,
    timeout: 3 * 60 * 1000
  });
}
// 对账单管理修改对账状态
export function reconciliationEditInvoiceStatus(data) {
  return request({
    url: '/balance/reconciliation/edit-invoice-status',
    method: 'post',
    data: data
  });
}
// 对账单添加备注
export function addReconciliationNotes(data) {
  return request({
    url: '/balance/reconciliation/add-note',
    method: 'post',
    data: data
  });
}
// 上传发票
export function uploadReconciliationInvoice(data) {
  return request({
    url: '/balance/reconciliation/upload-invoice',
    method: 'post',
    data: data
  });
}
// 删除发票
export function delReconciliationInvoiceImg(data) {
  return request({
    url: '/balance/reconciliation/delete-invoice',
    method: 'post',
    data: data
  });
}
// 修改分类编码
export function exitTaxClassCode(data) {
  return request({
    url: '/balance/balance-channel/edit-tax-class-code',
    method: 'post',
    data: data
  });
}
// 获取机器人配置
export function channelBotInfo(params) {
  return request({
    url: '/user/channel-bot/config',
    method: 'get',
    params: params
  });
}
// 保存配置
export function saveChannelBotInfo(data) {
  return request({
    url: '/user/channel-bot/save-config',
    method: 'post',
    data: data
  });
}
// 交易冲正
export function rectification(data) {
  return request({
    url: '/balance/balance-channel-review/rectify',
    method: 'post',
    data: data
  });
}
// 对账单详情页：交易明细-修改开票信息
export function changeReconciliationInvoiceItem(data) {
  return request({
    url: '/balance/reconciliation/edit-billing-item',
    method: 'post',
    data: data
  });
}
// 获取合同汇总
export function getContractTotal(params) {
  return request({
    url: '/user/channel/get-contract-total',
    method: 'get',
    params: params
  });
}

// 渠道充值审核-获取短信设置
export function getSmsStting(params) {
  return request({
    url: '/balance/balance-channel-review/sms-setting',
    method: 'get',
    params: params
  });
}
// 渠道充值审核-保存短信配置
export function saveSmsStting(data) {
  return request({
    url: 'balance/balance-channel-review/sms-setting',
    method: 'post',
    data: data
  });
}
// 导入对账单修改商品税收信息
export function reconciliationUploadFile(data) {
  return request({
    url: '/balance/reconciliation/upload-file',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 导入对账单修改商品税收信息
export function reconciliationDownloadTemplate(data) {
  return request({
    url: '/balance/reconciliation/download-template',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}

// 渠道管理-渠道余额监控-交易流水-操作日志
export function getLogActions(params) {
  return request({
    url: '/balance/balance-channel/log-actions',
    method: 'get',
    params: params
  });
}
// 渠道列表-电子卡密风控-查询
export function getCodeRisk(params) {
  return request({
    url: '/user/channel-code-risk/index',
    method: 'get',
    params: params
  });
}
// 渠道列表-电子卡密风控-查询
export function getView(params) {
  return request({
    url: '/user/channel-code-risk/view',
    method: 'get',
    params: params
  });
}
// 渠道列表-电子卡密风控-保存
export function saveSetting(data) {
  return request({
    url: '/user/channel-code-risk/save',
    method: 'post',
    data: data
  });
}
// 渠道列表-景点门票-查询
export function getTicketRisk(params) {
  return request({
    url: '/user/channel-ticket-risk/index',
    method: 'get',
    params: params
  });
}
// 渠道列表-景点门票-查询
export function getTicketView(params) {
  return request({
    url: '/user/channel-ticket-risk/view',
    method: 'get',
    params: params
  });
}
// 渠道列表-景点门票-保存
export function saveTicketSetting(data) {
  return request({
    url: '/user/channel-ticket-risk/save',
    method: 'post',
    data: data
  });
}
// 渠道列表-景点门票-用户下单风控限制 - 查询
export function getTicketOrderView(params) {
  return request({
    url: '/user/channel-ticket-risk/setting',
    method: 'get',
    params: params
  });
}
// 渠道列表-景点门票-用户下单风控限制 - 保存
export function saveTicketOrderSetting(data) {
  return request({
    url: '/user/channel-ticket-risk/save-setting',
    method: 'post',
    data: data
  });
}
// 渠道列表 - 蛋糕到家 - 用户下单风控限制 S
export function getCakeHomeRisk(params) {
  return request({
    url: '/user/cake-risk/index',
    method: 'get',
    params: params
  });
}
export function getCakeHomeView(params) {
  return request({
    url: '/user/cake-risk/view',
    method: 'get',
    params: params
  });
}
export function saveCakeHomeSetting(data) {
  return request({
    url: '/user/cake-risk/save',
    method: 'post',
    data: data
  });
}
// 渠道列表 - 蛋糕到家 - 用户下单风控限制 E

// 渠道列表 - 线下蛋糕 - 风控 S
export function getOffCakeRisk(params) {
  return request({
    url: '/user/off-cake-risk/index',
    method: 'get',
    params: params
  });
}
export function getOffCakeView(params) {
  return request({
    url: '/user/off-cake-risk/view',
    method: 'get',
    params: params
  });
}
export function saveOffCakeSetting(data) {
  return request({
    url: '/user/off-cake-risk/save',
    method: 'post',
    data: data
  });
}
// 渠道列表 - 线下蛋糕 - 风控 E

// 渠道列表-演出门票-查询
export function getPerformRisk(params) {
  return request({
    url: '/user/performance-risk/index',
    method: 'get',
    params: params
  });
}
// 渠道列表-演出门票-查询
export function getPerformView(params) {
  return request({
    url: '/user/performance-risk/view',
    method: 'get',
    params: params
  });
}
// 渠道列表-演出门票-保存
export function savePerformSetting(data) {
  return request({
    url: '/user/performance-risk/save',
    method: 'post',
    data: data
  });
}

/**
 * 渠道列表 - 风控配置 - 线上电影风控 - 查询
 * @param {*} params
 * @returns
 */
export function getMovieRisk(params) {
  return request({
    url: '/user/online-movie-risk/index',
    method: 'get',
    params: params
  });
}
/**
 * 渠道列表 - 风控配置 - 线上电影风控 - 查询
 * @param {*} params
 * @returns
 */
export function getMovieView(params) {
  return request({
    url: '/user/online-movie-risk/view',
    method: 'get',
    params: params
  });
}
/**
 * 渠道列表 - 风控配置 - 线上电影风控 - 保存
 * @param {*} data
 * @returns
 */
export function saveMovieSetting(data) {
  return request({
    url: '/user/online-movie-risk/save',
    method: 'post',
    data: data
  });
}
/**
 * 渠道列表 - 风控配置 - 线上电影风控 - 查询 用户下单风控限制
 * @param {*} params
 * @returns
 */
export function getMovieRiskSetting(params) {
  return request({
    url: '/user/online-movie-risk/setting',
    method: 'get',
    params: params
  });
}
/**
 * 渠道列表 - 风控配置 - 线上电影风控 - 保存 用户下单风控限制
 * @param {*} data
 * @returns
 */
export function setMovieRiskSetting(data) {
  return request({
    url: '/user/online-movie-risk/save-setting',
    method: 'post',
    data: data
  });
}

/**
 * 渠道列表 - 风控配置 - 手机号二次验证风控 - 查询/保存
 * @param {*} params
 * @param {*} method
 * @returns
 */
export function getPhoneRiskSetting(params) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  return request(_defineProperty({
    url: '/user/channel/mobile-risk',
    method: method
  }, method === 'get' ? 'params' : 'data', params));
}

/**
 * 渠道列表 - 风控配置 - 接码手机号风控 - 查询
 * @param {*} params
 * @returns
 */
export function getPhoneRisk(params) {
  return request({
    url: '/user/receive-mobile-risk/index',
    method: 'get',
    params: params
  });
}
/**
 * 渠道列表 - 风控配置 - 接码手机号风控 - 查询
 * @param {*} params
 * @returns
 */
export function getPhoneView(params) {
  return request({
    url: '/user/receive-mobile-risk/view',
    method: 'get',
    params: params
  });
}
/**
 * 渠道列表 - 风控配置 - 接码手机号风控 - 保存
 * @param {*} data
 * @returns
 */
export function savePhoneSetting(data) {
  return request({
    url: '/user/receive-mobile-risk/save',
    method: 'post',
    data: data
  });
}
// 渠道列表-电子卡密风控-开关
export function riskSwitch(params) {
  return request({
    url: '/user/channel-code-risk/switch',
    method: 'get',
    params: params
  });
}
//获取订单风控
export function getChannelRiskConfig(params) {
  return request({
    url: '/orders/order-risk-config/get-channel-config',
    method: 'get',
    params: params
  });
}
//获取订单消费风控预警
export function getChannelConsumeRemind(params) {
  return request({
    url: '/orders/order-consume-remind-config/get-channel',
    method: 'get',
    params: params
  });
}
//订单设置风控级别
export function channelSetRiskConfig(data) {
  return request({
    url: '/orders/order-risk-config/set-config',
    method: 'post',
    data: data
  });
}
//订单设置风控级别
export function channelSetconsumeConfig(data) {
  return request({
    url: '/orders/order-consume-remind-config/set-channel',
    method: 'post',
    data: data
  });
}
// 商城域名-保存
export function saveChannelUrl(data) {
  return request({
    url: '/user/channel/save-channel-url-data',
    method: 'post',
    data: data
  });
}
//获取短信发送记录
export function getAllSmsLog(params) {
  return request({
    url: '/customer/channel-sms-bill/get-all-sms-log',
    method: 'get',
    params: params
  });
}

//获取偏差金额
export function getAmount(params) {
  return request({
    url: '/balance/reconciliation/edit-preview-deviation-amount',
    method: 'get',
    params: params
  });
}
// 修改偏差金额
export function editAmount(data) {
  return request({
    url: '/balance/reconciliation/edit-preview-deviation-amount',
    method: 'post',
    data: data
  });
}
//获取偏差金额
export function detailGetAmount(params) {
  return request({
    url: '/balance/reconciliation/edit-deviation-amount',
    method: 'get',
    params: params
  });
}
// 修改偏差金额
export function detailEditAmount(data) {
  return request({
    url: '/balance/reconciliation/edit-deviation-amount',
    method: 'post',
    data: data
  });
}

//获取渠道电影出票配置
export function getMarketingInfo(params) {
  return request({
    url: '/user/channel/get-ticket-way',
    method: 'get',
    params: params
  });
}
// 设置渠道电影出票配置
export function saveMarketingInfo(data) {
  return request({
    url: '/user/channel/set-ticket-way',
    method: 'post',
    data: data
  });
}
//获取渠道管理-渠道对账管理-导入修改商品税收信息- 数量
export function getTotalInfo(params) {
  return request({
    url: '/products/goods-check/get-total-info',
    method: 'get',
    params: params
  });
}
//渠道获取用户绑卡风控
export function getBindCardConfig(params) {
  return request({
    url: '/user/channel-risk/bind-card-config',
    method: 'get',
    params: params
  });
}
//渠道保存用户绑卡风控
export function saveBindCardConfig(data) {
  return request({
    url: '/user/channel-risk/save-bind-card-config',
    method: 'post',
    data: data
  });
}
//客户保存用户绑卡风控
export function getAccountBindCardConfig(params) {
  return request({
    url: '/customer/customer-account-new/bind-card-config',
    method: 'get',
    params: params
  });
}
//客户获取用户绑卡风控
export function saveAccountBindCardConfig(data) {
  return request({
    url: '/customer/customer-account-new/save-bind-card-config',
    method: 'post',
    data: data
  });
}
// 获取小规模纳税人配置
export function getTaxpayerConfig(params) {
  return request({
    url: '/user/channel-small-scale-taxpayer/get-config',
    method: 'get',
    params: params
  });
}
// 设置小规模纳税人配置
export function setTaxpayerConfig(data) {
  return request({
    url: '/user/channel-small-scale-taxpayer/set-config',
    method: 'post',
    data: data
  });
}
// 获取邮箱配置
export function getUserEmail(params) {
  return request({
    url: '/user/channel/save-email',
    method: 'get',
    params: params
  });
}
// 保存邮箱配置
export function saveUserEmail(data) {
  return request({
    url: '/user/channel/save-email',
    method: 'post',
    data: data
  });
}
// 获取渠道订单配置
export function getChannelOrderConfig(data) {
  return request({
    url: '/orders/add-order-config/get-channel-config',
    method: 'post',
    data: data
  });
}
// 设置渠道订单配置
export function setChannelOrderConfig(data) {
  return request({
    url: '/orders/add-order-config/set-channel-config',
    method: 'post',
    data: data
  });
}
// 查看验证码
export function getSmsContent(params) {
  return request({
    url: '/customer/channel-sms-bill/get-sms-content',
    method: 'get',
    params: params
  });
}
// 获取日志
export function getSmsContentLog(params) {
  return request({
    url: '/customer/channel-sms-bill/get-sms-user-log',
    method: 'get',
    params: params
  });
}
// 修改流水号
export function upSerialNo(data) {
  return request({
    url: '/balance/balance-channel-review/up-serial-no ',
    method: 'post',
    data: data
  });
}
// 渠道对帐管理 导出对账单
export function exportStatement(params) {
  return request({
    url: '/balance/reconciliation/export-all',
    method: 'get',
    params: params
  });
}
// 菜单日志 搜索
export function getCategoryLogType(params) {
  return request({
    url: '/malldecoration/channel-category/get-category',
    method: 'get',
    params: params
  });
}
// 菜单日志 列表
export function getCategoryLogList(params) {
  return request({
    url: '/malldecoration/channel-category/get-category-log',
    method: 'get',
    params: params,
    timeout: 3 * 60 * 1000
  });
}

// 自营商品成本统计
export function getStatistics(params) {
  return request({
    url: '/balance/balance-channel/goods-statistics',
    method: 'get',
    params: params
  });
}

// 自营商品成本统计导出
export function getStatisticsExport(params) {
  return request({
    url: '/balance/balance-channel/goods-statistics-export',
    method: 'get',
    params: params
  });
}

// 自营商品成本流水
export function getGoodsLog(params) {
  return request({
    url: '/balance/balance-channel/goods-log',
    method: 'get',
    params: params
  });
}

// 自营商品成本流水导出
export function getGoodsLogExport(params) {
  return request({
    url: '/balance/balance-channel/goods-log-export',
    method: 'get',
    params: params
  });
}

// 更新渠道协议配置
export function postUpdateAgreementConfig(data) {
  return request({
    url: '/user/channel/update-agreement',
    method: 'post',
    data: data
  });
}

// 获取渠道协议配置
export function getUpdateAgreementConfig(params) {
  return request({
    url: '/user/channel/update-agreement',
    method: 'GET',
    params: params
  });
}